var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack132Copy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8.03 7.73 14.07 4.22 14.05 11.2 8.01 14.71 8.03 7.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "1.95 4.22 7.99 0.71 14.07 4.22 8.03 7.73 1.95 4.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8.03 7.73 8.01 14.71 1.93 11.2 1.95 4.22 8.03 7.73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack132Copy);
export default __webpack_public_path__ + "static/media/Symbolpack_1_32_Copy.b801276ae811b698721b1d8fcd96c2c1.svg";
export { ForwardRef as ReactComponent };